import React,{forwardRef,useEffect, useRef, useState, Fragment} from 'react'
import styles from './scrollbar.module.css'
import gsap from "gsap";
import { Draggable } from "gsap/all";
import classNames from 'classnames';
gsap.registerPlugin(Draggable)

const ScrollBar = forwardRef((props, ref)=>{
    const scrollBar = useRef();
    const handle = useRef();
    const draggableInstance = useRef(null);

    function onDragHandling(e){
        if (props.isVertical) {
            let offset = (e.y)-(scrollBar.current.offsetHeight/2);
            let yPos = offset/scrollBar.current.offsetHeight * (props.height - window.innerHeight)/2;

            if (offset < 0) {
                yPos = yPos + 0;
            } else {
                yPos = yPos - 0;
            }
         
            // console.log('yPos', offset, yPos, props.height, e.y, scrollBar.current.offsetHeight)
            gsap.to(props.scrollingContainer, {y: yPos, duration: 0.2})
        } else {
            let offset = e.x-scrollBar.current.getBoundingClientRect().left;
            let scrollingOffset = document.getElementById("event_" + props.firstEventId).offsetLeft;

            // console.log('scrollingOffset',scrollingOffset)
            let xPos = offset/scrollBar.current.offsetWidth * (props.width - window.innerWidth);
            
            if (xPos > props.width - window.innerWidth) {
                xPos = props.width - window.innerWidth
            }
            if (xPos < -200) {
                xPos = 0
            }
            gsap.to(props.scrollingContainer, {x: -xPos, duration: 0.2})
            // console.log('xPos', xPos)
            props.onScroll()
        }
    }

    useEffect(() => {
        // handle.current.style.left = "100px";
    }, [])

    useEffect(()=>{
        draggableInstance.current = Draggable.create(handle.current, {
        type: props.isVertical ? "y" : "x",
        bounds: scrollBar.current,
        inertia: false,
        edgeResistance: 1,
        onDragStart: function(e) {
            let offset = -(e.x - scrollBar.current.getBoundingClientRect().left);
        },
        onDrag: function(e) {
            onDragHandling(e);
        },
        onDragEnd: function(e) {
            onDragHandling(e);
        }
    })[0]; // Draggable.create returns an array
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[props.width, props.height])

    useEffect(() => {
    if (draggableInstance.current) {
        props.draggable ? draggableInstance.current.enable() : draggableInstance.current.disable();
    }
    }, [props.draggable]);

    return (
        <Fragment>
            <div className={classNames(props.isVertical ? styles.scrollBarV : styles.scrollBar)} ref={scrollBar} id={props.isVertical ? "scrollBarV" : "scrollBar"}>
                <div className={styles.scrollHandle} id={props.isVertical ? "scrollHandleV" : "scrollHandle"} ref={handle}></div>
            </div>
        </Fragment>
    )

})

export default ScrollBar;